'use client'

import { useContext } from 'react'
import { Context as RollbarReactContext } from '@rollbar/react'

// No-op rollbar that silently falls back to console when no RollbarProvider is in the tree.
// Prevents "Cannot read properties of undefined (reading 'Symbol(RollbarInstance)')" on
// public pages (resources, services) where we intentionally skip the provider.
const noopRollbar = {
  error: (...args: unknown[]) => console.error(...args),
  warn: (...args: unknown[]) => console.warn(...args),
  info: (...args: unknown[]) => console.info(...args),
  debug: (...args: unknown[]) => console.debug(...args),
  critical: (...args: unknown[]) => console.error(...args),
  log: (...args: unknown[]) => console.log(...args),
}

export function useSafeRollbar() {
  const ctx = useContext(RollbarReactContext) as any
  // ctx is the Rollbar instance stored in context; undefined/null/empty when no provider.
  // Use noopRollbar if ctx lacks the expected .error method (e.g. default context value is {}).
  return ctx && typeof ctx.error === 'function' ? ctx : noopRollbar
}
